// src/pages/Solutions.js
// Overview page listing all solution areas.
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';
import CtaBanner from '../components/CtaBanner';
import { SOLUTIONS } from '../data/solutions';

const Solutions = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageMeta
                title={t('solutions_page.meta_title')}
                description={t('solutions_page.meta_description')}
                path="/solutions"
            />
            <StructuredData type="page" page={{ name: t('nav.solutions'), path: '/solutions', kind: 'CollectionPage', description: t('solutions_page.meta_description') }} />

            {/* Page header */}
            <div className="bg-slate-900 py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-aos="fade-up">
                    <h1 className="text-4xl font-bold text-white mb-4">{t('solutions_page.title')}</h1>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">{t('solutions_page.subtitle')}</p>
                </div>
            </div>

            {/* Solution cards */}
            <div className="bg-gray-100 py-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-8">
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-6">
                        {SOLUTIONS.map((s, i) => (
                            <Link
                                key={s.slug}
                                to={`/solutions/${s.slug}`}
                                className="bg-white group rounded-lg shadow-xl p-6 flex flex-col transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 border-t-4 border-transparent hover:border-primary"
                                data-aos="fade-up"
                                data-aos-delay={(i % 2) * 100}
                            >
                                <div className="flex items-center mb-3">
                                    <div className="text-primary mr-3">{s.icon}</div>
                                    <h2 className="font-bold text-xl text-gray-800 group-hover:text-primary transition-colors">
                                        {t(`solutions.${s.key}.title`)}
                                    </h2>
                                </div>
                                <p className="text-gray-700 font-semibold mb-2">{t(`solutions.${s.key}.tagline`)}</p>
                                <p className="text-gray-600 flex-grow text-justify">{t(`solutions.${s.key}.problem`)}</p>
                                <span className="mt-4 text-primary font-semibold inline-flex items-center">
                                    {t('common.learn_more')}
                                    <svg className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                </span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>

            <CtaBanner
                title={t('solutions_common.cta_title')}
                text={t('solutions_common.cta_text')}
                buttonLabel={t('solutions_common.cta_button')}
            />
        </>
    );
};

export default Solutions;
